export default {
  "content": "<path d=\"M12 2a9.973 9.973 0 017.071 2.928A9.973 9.973 0 0122 12c0 5.523-4.477 10-10 10S2 17.523 2 12h2a8 8 0 1016 0c0-2.209-.894-4.208-2.343-5.657A7.973 7.973 0 0012 4V2z\" fill=\"#7B61FF\"/><path d=\"M13 12h2.5v2H12a1 1 0 01-1-1V8.5h2V12zM5.667 7.112a7.963 7.963 0 00-1.468 3.11l-1.95-.443a9.965 9.965 0 011.836-3.89l1.582 1.223zM10.222 4.199c-1.15.26-2.206.769-3.11 1.468L5.89 4.083a9.965 9.965 0 013.89-1.836l.443 1.95z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};